import React, { useEffect } from 'react'
import logger from '@adc/logger'

type JumioVerificationProps = {
  frameUrl: string
  onVerify: (result?: string) => void
}

const JumioVerification = ({ frameUrl, onVerify }: JumioVerificationProps) => {
  useEffect(() => {
    const receiveMessage = async (event?: { data?: string }) => {
      let val = null
      try {
        val = JSON.parse(event?.data ?? '').payload?.value
      } catch (e) {
        // Unknown Event, probably from a browser extension
        logger.error('Caught unexpected page message', e)
      } finally {
        if (typeof val === 'string' && ['success', 'error'].includes(val)) {
          onVerify(val)
        }
      }
    }
    window.addEventListener('message', receiveMessage, false)
    return () => window.removeEventListener('message', receiveMessage, false)
  }, [frameUrl, onVerify])

  return <iframe src={frameUrl} width='100%' height='500px' allow='camera' />
}

export default JumioVerification
